var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgJiraLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.245 8.024 8.93.71 8.221 0 2.715 5.507.197 8.024a.673.673 0 0 0 0 .952l5.03 5.03L8.222 17l5.507-5.507.085-.085 2.432-2.432a.673.673 0 0 0 0-.952Zm-8.024 2.99L5.708 8.5l2.513-2.513L10.734 8.5l-2.513 2.513Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22 5.987A4.232 4.232 0 0 1 8.204.021l-5.5 5.497 2.993 2.993 2.525-2.524Z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m10.742 8.493-2.52 2.52a4.232 4.232 0 0 1 0 5.987l5.513-5.513-2.993-2.994Z",
    fill: "url(#b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 7.772,
    y1: 3.445,
    x2: 4.262,
    y2: 6.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 222.027,
    y1: 521.275,
    x2: 343.237,
    y2: 442.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgJiraLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/jira-logo.83c390d0d2dceaaea93cb74f8a3f7903.svg";